import { Controller } from 'stimulus';

export default class extends Controller {
  iconTarget: HTMLElement;

  static get targets() {
    return ['icon'];
  }

  static get values() {
    return { text: String };
  }

  declare textValue: string;

  copy() {
    navigator.clipboard.writeText(this.textValue);

    this.iconTarget.classList.remove('fa-copy');
    this.iconTarget.classList.add('fa-check');
    setTimeout(() => {
      this.iconTarget.classList.remove('fa-check');
      this.iconTarget.classList.add('fa-copy');
    }, 1000);
  }
}
